// extracted by mini-css-extract-plugin
export default {"task-list":"TaskList_task-list__kXmOA"};